'use client';
import React from 'react';
import styled from '@benzinga/themetron';

// import { usePermission } from '@benzinga/user-context';
import {
  ContentManager,
  PodcastPost,
  WordpressPost,
  WordpressSidebar,
  WordpressWidget,
} from '@benzinga/content-manager';
import { SessionContext } from '@benzinga/session-context';
import { useIsUserEditor } from '@benzinga/user-context';
import Hooks from '@benzinga/hooks';
import { Button } from '@benzinga/core-ui';

interface LayoutAdminProps {
  post: WordpressPost | WordpressSidebar | WordpressWidget | PodcastPost | null;
  showClearCache?: boolean;
  type?: string;
  className?: string;
  wordpressUrl?: string;
}

export const LayoutAdmin: React.FC<LayoutAdminProps> = ({ className, post, showClearCache, type, wordpressUrl }) => {
  const canEdit = Hooks.useHydrate(useIsUserEditor(), false);
  const [isEditorModeEnabled] = Hooks.useLocalStorage('editor_mode_enabled', false);
  const isEditorModeEnabledHydrated = Hooks.useHydrate(isEditorModeEnabled, false);

  const session = React.useContext(SessionContext);

  const handleClick = React.useCallback(() => {
    if (wordpressUrl) {
      window.open(wordpressUrl, '_blank');
    } else {
      post?.id && window.open(`https://www.benzinga.com/wp-admin/post.php?post=${post?.id}&action=edit`, '_blank');
    }
  }, [post?.id, wordpressUrl]);

  const handleClearCache = React.useCallback(() => {
    if (post?.canonical_link) {
      session
        .getManager(ContentManager)
        .clearCache(
          post.canonical_link?.replace('https://www.benzinga.com/', '').replace('https://in.benzinga.com/', ''),
        )
        .then(() => {
          global.location.reload();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [post?.canonical_link]);

  if ((!post?.id && !wordpressUrl) || (!post?.canonical_link && showClearCache)) return null;
  if (!canEdit) return null;
  if (!isEditorModeEnabledHydrated) return null;

  const typeText = (type || post?.type || post?.['template'] || '').replace('_', ' ');

  return (
    <Container className={className}>
      <StyledButton onClick={handleClick} variant="primary">
        Edit {typeText}
      </StyledButton>
      {showClearCache && post?.canonical_link && (
        <StyledButton onClick={handleClearCache} variant="warning">
          Clear cache
        </StyledButton>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  margin-right: 0.5rem;
  height: 30px;
`;
